import React from 'react';
import { SD_PALETTE } from '../../lib/sdColors';
import { LegendCard } from './LegendCard';
import { CategoricalLegend } from './CategoricalLegend';

/**
 * Floating legend for the Stand Density map overlay. Colors match the
 * left-panel bar chart so a red pixel on the map is the same overstocked
 * (80%+) bin the left-panel bar counts.
 */
export const SdMapLegend: React.FC = () => (
  <LegendCard title="Relative Density — % of biological max" positioned>
    <CategoricalLegend palette={SD_PALETTE} />
  </LegendCard>
);
